export default __webpack_public_path__ + "static/media/lisa_on.868c371c.png";